/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'./PlaceholderView',
	'text!./IconPlaceholder.html',
	'../../util/TextFitUtil',
	'../../../lib/@waca/core-client/js/core-client/utils/Utils',
	'../../../app/nls/StringResources',
	'@ba/ba-graphics/dist/illustrations-js/text-widget_128',
	'@ba/ba-graphics/dist/illustrations-js/box-light'
], function(BaseClass, Template, TextFitUtil, Utils, stringResources, textWidget128, buildVis200) {
	var IconPlaceholderView = null;

	const ICON_PLACEHOLDERS = {
		text: {
			iconName: textWidget128.default.id,
			text: stringResources.get('textWidgetIconPlaceholderText')
		},
		list: {
			text: stringResources.get('textWidgetIconPlaceholderText')
		},
		vis: {
			iconName: buildVis200.default.id,
			headerText: stringResources.get('buildVisHeader'),
			text: stringResources.get('visIconPlaceholderText')
		}
	};

	IconPlaceholderView = BaseClass.extend({
		templateString: Template,

		init: function(options = {}) {
			IconPlaceholderView.inherited('init', this, arguments);
			this.type = options.iconType || 'text';
		},

		render: function() {
			let sHtml = this.dotTemplate({
				placeholderHeader: ICON_PLACEHOLDERS[this.type].headerText,
				placeholderText: ICON_PLACEHOLDERS[this.type].text
			});
			this.$el.append(sHtml);
			this.resize();
			const iconPlaceholder = ICON_PLACEHOLDERS[this.type].iconName;
			iconPlaceholder && Utils.setIcon(this.$el.find('.placeholder .iconContainer'), iconPlaceholder);
		},

		show: function() {
			IconPlaceholderView.inherited('show', this, arguments);
			this.fillText();
		},

		resize: function() {
			const maxHeight = 220;
			const maxWidth = 180;

			if (this.$el.height() < maxHeight || this.$el.width() < maxWidth) {
				this.$el.find('.placeholder').addClass('compact');
			} else {
				this.$el.find('.placeholder').removeClass('compact');
			}

			this.fillText();
		},

		fillText: function() {
			const instructionTextNode = this.el.querySelector('.instructionText');
			const instructionHeaderNode = this.el.querySelector('.instructionTextHeader');
			// Return if the two nodes don't exist or their parent are hidden
			if ((!instructionTextNode || instructionTextNode.parentElement.style.display === 'none' ) && (!instructionHeaderNode || instructionHeaderNode.parentElement.style.display === 'none')) {
				return;
			}
			const options = {
				maxFontSize: 14,
				minFontSize: 1,
				multiLine: true,
				detectMultiLine: false,
				alignHoriz: true,
				widthOnly: true
			};
			if(instructionTextNode) {
				TextFitUtil.fillText(instructionTextNode, options);
			}
			if(instructionHeaderNode) {
				TextFitUtil.fillText(instructionHeaderNode, options);
			}

		}
	});

	return IconPlaceholderView;
});
